var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" ID: "+_vm._s(_vm.id)+" "),_c('v-text-field',{attrs:{"label":"Temp Field"},model:{value:(_vm.tempString),callback:function ($$v) {_vm.tempString=$$v},expression:"tempString"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }